var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { GA4DataLayerEvent } from "../dto/GoogleAnalytics/GA4DataLayerEvent";
import { ProductDto } from "../dto";
import { ProductApi } from "../ocapi";
import { buildGAItem, getBrandName } from "../helpers";
var GAService = (function () {
    function GAService() {
        var _this = this;
        this.getProductData = function (productIds) { return __awaiter(_this, void 0, void 0, function () {
            var ocapiResponse, products;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4, new ProductApi().getProducts(productIds)];
                    case 1:
                        ocapiResponse = _c.sent();
                        if (!ocapiResponse || !ocapiResponse.count || !ocapiResponse.data)
                            return [2, []];
                        products = (_b = (_a = ocapiResponse.data) === null || _a === void 0 ? void 0 : _a.map(function (product) {
                            return new ProductDto(product);
                        })) !== null && _b !== void 0 ? _b : [];
                        return [2, products];
                }
            });
        }); };
        this.signUpEvent = function (gaSignUpEvent) {
            var _a;
            if (!gaSignUpEvent.ba_agent_id)
                delete gaSignUpEvent.ba_agent_id;
            var DLEvent = {
                event: "sign_up",
                user: __assign({}, gaSignUpEvent)
            };
            (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push(DLEvent);
        };
        this.addShippingInformation = function (items, hasGiftCard, affiliation, value, shippingMethod, coupons, donationValue) {
            var _a, _b, _c;
            var options = {
                currency: (_a = window.reactSystemData) === null || _a === void 0 ? void 0 : _a.currencyCode,
                affiliation: affiliation,
                shipping_tier: shippingMethod,
                value: value
            };
            if (donationValue && donationValue > 0) {
                options.donation_value = donationValue;
            }
            var DLEvent = GAService.buildEvent('add_shipping_info', items, options);
            if (hasGiftCard)
                DLEvent.ecommerce.coupon = 'GIFT CARD';
            coupons === null || coupons === void 0 ? void 0 : coupons.forEach(function (coupon, index) {
                if (index === 0 && !hasGiftCard) {
                    DLEvent.ecommerce.coupon = coupon;
                }
                else {
                    DLEvent.ecommerce["coupon" + (!hasGiftCard ? index : index + 1)] = coupon;
                }
            });
            (_b = window.dataLayer) === null || _b === void 0 ? void 0 : _b.push({ ecommerce: null });
            (_c = window.dataLayer) === null || _c === void 0 ? void 0 : _c.push(DLEvent);
        };
        this.addBillingInformation = function (items, hasGiftCard, orderTotalValue, paymentMethod, coupons, donationValue) {
            var _a, _b, _c;
            var paymentType = "";
            if (paymentMethod) {
                switch (paymentMethod) {
                    case 'CREDIT_CARD':
                        paymentType = 'Credit Card';
                        break;
                    case 'PayPal':
                        paymentType = 'PayPal';
                        break;
                    case 'AFTERPAY_PBI':
                        paymentType = 'AfterPay';
                        break;
                    case 'ApplePay':
                        paymentType = 'ApplePay';
                        break;
                }
            }
            var options = {
                currency: (_a = window.reactSystemData) === null || _a === void 0 ? void 0 : _a.currencyCode,
                payment_type: paymentType,
                value: orderTotalValue
            };
            if (hasGiftCard) {
                options.coupon = 'GIFT_CARD';
            }
            if (donationValue && donationValue > 0) {
                options.donation_value = donationValue;
            }
            var DLEvent = GAService.buildEvent('add_payment_info', items, options);
            coupons === null || coupons === void 0 ? void 0 : coupons.forEach(function (coupon, index) {
                if (index === 0 && !hasGiftCard) {
                    DLEvent.ecommerce.coupon = coupon;
                }
                else {
                    DLEvent.ecommerce["coupon" + (!hasGiftCard ? index : index + 1)] = coupon;
                }
            });
            (_b = window.dataLayer) === null || _b === void 0 ? void 0 : _b.push({ ecommerce: null });
            (_c = window.dataLayer) === null || _c === void 0 ? void 0 : _c.push(DLEvent);
        };
        this.purchaseEvent = function (items, orderId, value, shipping, tax, affiliation, coupons, donationValue, hasGiftCard, email, phone) {
            if (hasGiftCard === void 0) { hasGiftCard = false; }
            var _a, _b, _c, _d;
            var options = {
                currency: (_a = window.reactSystemData) === null || _a === void 0 ? void 0 : _a.currencyCode,
                value: value,
                affiliation: (_b = getBrandName()) !== null && _b !== void 0 ? _b : affiliation,
                transaction_id: orderId,
                shipping: shipping,
                tax: tax,
                phone: phone,
                email: email,
            };
            if (donationValue && donationValue > 0) {
                options.donation_value = donationValue;
            }
            if (hasGiftCard)
                coupons === null || coupons === void 0 ? void 0 : coupons.push('GIFT_CARD');
            var DLEvent = GAService.buildEvent('purchase', items, options);
            coupons === null || coupons === void 0 ? void 0 : coupons.forEach(function (coupon, index) {
                if (index === 0) {
                    DLEvent.ecommerce.coupon = coupon;
                }
                else {
                    DLEvent.ecommerce["coupon" + index] = coupon;
                }
            });
            (_c = window.dataLayer) === null || _c === void 0 ? void 0 : _c.push({ ecommerce: null });
            (_d = window.dataLayer) === null || _d === void 0 ? void 0 : _d.push(DLEvent);
        };
        this.buildEventFromProductIds = function (productIds, eventName, itemListName) { return __awaiter(_this, void 0, void 0, function () {
            var products, DLEvent, DLEvent, DLEvent;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0: return [4, this.getProductData(productIds)];
                    case 1:
                        products = _k.sent();
                        if (eventName === 'view_item_list') {
                            DLEvent = GAService.buildEvent('view_item_list', GAService.getGA4ItemFromProductDto(products, undefined, itemListName ? itemListName : (_c = (_b = (_a = window) === null || _a === void 0 ? void 0 : _a.reactPageData) === null || _b === void 0 ? void 0 : _b.cgid) !== null && _c !== void 0 ? _c : undefined));
                            (_d = window.dataLayer) === null || _d === void 0 ? void 0 : _d.push({ ecommerce: null });
                            (_e = window.dataLayer) === null || _e === void 0 ? void 0 : _e.push(DLEvent);
                            return [2];
                        }
                        else if (eventName === 'select_item') {
                            DLEvent = GAService.buildEvent('select_item', GAService.getGA4ItemFromProductDto(products));
                            (_f = window.dataLayer) === null || _f === void 0 ? void 0 : _f.push({ ecommerce: null });
                            (_g = window.dataLayer) === null || _g === void 0 ? void 0 : _g.push(DLEvent);
                            return [2];
                        }
                        else if (eventName === 'remove_from_cart') {
                            DLEvent = GAService.buildEvent('remove_from_cart', GAService.getGA4ItemFromProductDto(products, undefined, 'Cart'));
                            (_h = window.dataLayer) === null || _h === void 0 ? void 0 : _h.push({ ecommerce: null });
                            (_j = window.dataLayer) === null || _j === void 0 ? void 0 : _j.push(DLEvent);
                        }
                        return [2];
                }
            });
        }); };
        this.promotionEvent = function (promotionData, eventName) { return __awaiter(_this, void 0, void 0, function () {
            var items, products, DLEvent;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        items = undefined;
                        if (!promotionData.productIds) return [3, 2];
                        return [4, this.getProductData(promotionData.productIds)];
                    case 1:
                        products = _c.sent();
                        items = GAService.getGA4ItemFromProductDto(products);
                        _c.label = 2;
                    case 2:
                        delete promotionData.productIds;
                        DLEvent = GAService.buildEvent(eventName, items, undefined, __assign(__assign({}, promotionData), { Position: 1 }));
                        (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ ecommerce: null });
                        (_b = window.dataLayer) === null || _b === void 0 ? void 0 : _b.push(DLEvent);
                        return [2];
                }
            });
        }); };
        this.removeCartItem = function (productId, itemListName, productQuantity) { return __awaiter(_this, void 0, void 0, function () {
            var productData, product, price, value, DLEvent;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4, this.getProductData([productId])];
                    case 1:
                        productData = _f.sent();
                        product = productData === null || productData === void 0 ? void 0 : productData[0];
                        price = (_b = (_a = product === null || product === void 0 ? void 0 : product.promoPrice) !== null && _a !== void 0 ? _a : product === null || product === void 0 ? void 0 : product.price) !== null && _b !== void 0 ? _b : 0;
                        value = price * (productQuantity || 1);
                        DLEvent = GAService.buildEvent('remove_from_cart', GAService.getGA4ItemFromProductDto(productData, undefined, itemListName, productQuantity), {
                            currency: (_c = window.reactSystemData) === null || _c === void 0 ? void 0 : _c.currencyCode,
                            value: value
                        });
                        (_d = window.dataLayer) === null || _d === void 0 ? void 0 : _d.push({ ecommerce: null });
                        (_e = window.dataLayer) === null || _e === void 0 ? void 0 : _e.push(DLEvent);
                        return [2];
                }
            });
        }); };
    }
    GAService.getGA4ItemFromProductDto = function (products, selected, itemListName, productQuantity) {
        var _this = this;
        return products.map(function (product, index) {
            var _a, _b, _c, _d;
            var product_id = (_b = (_a = selected === null || selected === void 0 ? void 0 : selected.id) !== null && _a !== void 0 ? _a : product === null || product === void 0 ? void 0 : product.id) !== null && _b !== void 0 ? _b : '';
            var price = 0;
            var fullPrice = 0;
            var discount = 0;
            if (product.isProductSet) {
                price = (product.overrideDisplayPrice && product.overrideDisplayPrice !== 0) ? product.overrideDisplayPrice : (product.promoPrice && product.promoPrice !== 0) ? product.promoPrice : product.setTotalPrice || 0;
                fullPrice = product.setTotalPrice || 0;
                discount = fullPrice - price;
            }
            else {
                price = selected && selected.promoPrice ? selected.promoPrice : (product.overrideDisplayPrice && product.overrideDisplayPrice !== 0) ? product.overrideDisplayPrice : (product.promoPrice && product.promoPrice !== 0) ? product.promoPrice : product.price;
                fullPrice = selected && selected.price ? selected.price : product.price;
                discount = fullPrice - price;
            }
            var item_category = (_c = product.primaryCategoryId) !== null && _c !== void 0 ? _c : '';
            var variationAttributes = ['color', 'size'];
            var item_variant = "";
            variationAttributes.forEach(function (variantAttribute) {
                var itemVariant = product.isMaster ? selected === null || selected === void 0 ? void 0 : selected[variantAttribute] : product.isVariant ? (selected === null || selected === void 0 ? void 0 : selected[variantAttribute]) ? selected === null || selected === void 0 ? void 0 : selected[variantAttribute] : product[variantAttribute] : "";
                if (!!itemVariant)
                    item_variant = itemVariant;
            });
            var GA4Item = {
                item_id: product_id,
                item_name: product.name,
                affiliation: _this.affiliation,
                currency: (_d = window.reactSystemData) === null || _d === void 0 ? void 0 : _d.currencyCode,
                discount: (discount % 1 !== 0) ? parseFloat(discount.toFixed(2)) : discount,
                index: index,
                item_brand: _this.item_brand,
                item_category: item_category,
                item_list_name: itemListName !== null && itemListName !== void 0 ? itemListName : item_category,
                item_variant: item_variant,
                price: fullPrice,
                quantity: productQuantity || 1
            };
            return GA4Item;
        });
    };
    GAService.buildEvent = function (eventName, items, options, promotion) {
        var _a, _b;
        var gaEcommerce = {};
        var gaEcommerceUser = {};
        if (items)
            gaEcommerce.items = items;
        if (promotion)
            gaEcommerce.promotion = promotion;
        if (options === null || options === void 0 ? void 0 : options.value)
            gaEcommerce.value = options === null || options === void 0 ? void 0 : options.value;
        if (options === null || options === void 0 ? void 0 : options.currency)
            gaEcommerce.currency = options === null || options === void 0 ? void 0 : options.currency;
        if (options === null || options === void 0 ? void 0 : options.affiliation)
            gaEcommerce.affiliation = options === null || options === void 0 ? void 0 : options.affiliation;
        if (options === null || options === void 0 ? void 0 : options.shipping_tier)
            gaEcommerce.shipping_tier = options === null || options === void 0 ? void 0 : options.shipping_tier;
        if (options === null || options === void 0 ? void 0 : options.payment_type)
            gaEcommerce.payment_type = options === null || options === void 0 ? void 0 : options.payment_type;
        if (options === null || options === void 0 ? void 0 : options.coupon)
            gaEcommerce.coupon = options === null || options === void 0 ? void 0 : options.coupon;
        if (options === null || options === void 0 ? void 0 : options.coupon2)
            gaEcommerce.coupon2 = options === null || options === void 0 ? void 0 : options.coupon2;
        if (options === null || options === void 0 ? void 0 : options.coupon3)
            gaEcommerce.coupon3 = options === null || options === void 0 ? void 0 : options.coupon3;
        if (options === null || options === void 0 ? void 0 : options.coupon4)
            gaEcommerce.coupon4 = options === null || options === void 0 ? void 0 : options.coupon4;
        if (options === null || options === void 0 ? void 0 : options.coupon5)
            gaEcommerce.coupon5 = options === null || options === void 0 ? void 0 : options.coupon5;
        if (options === null || options === void 0 ? void 0 : options.transaction_id)
            gaEcommerce.transaction_id = options === null || options === void 0 ? void 0 : options.transaction_id;
        if (options === null || options === void 0 ? void 0 : options.shipping)
            gaEcommerce.shipping = options === null || options === void 0 ? void 0 : options.shipping;
        if (options === null || options === void 0 ? void 0 : options.tax)
            gaEcommerce.tax = options === null || options === void 0 ? void 0 : options.tax;
        if (options === null || options === void 0 ? void 0 : options.user)
            gaEcommerce.user = options === null || options === void 0 ? void 0 : options.user;
        if (options === null || options === void 0 ? void 0 : options.donation_value)
            gaEcommerce.donation_value = options.donation_value;
        if ((options === null || options === void 0 ? void 0 : options.phone) || (options === null || options === void 0 ? void 0 : options.email)) {
            gaEcommerceUser = {
                user_phone_number: (_a = options.phone) !== null && _a !== void 0 ? _a : "",
                user_email: (_b = options.email) !== null && _b !== void 0 ? _b : ""
            };
        }
        return new GA4DataLayerEvent(eventName, gaEcommerce, !!Object.keys(gaEcommerceUser).length ? gaEcommerceUser : undefined);
    };
    GAService.viewItemList = function (products, isSearch, itemListName) {
        var _this = this;
        if (isSearch === void 0) { isSearch = false; }
        var _a, _b;
        var DLEvent = this.buildEvent('view_item_list', products.map(function (product, index) {
            var _a, _b, _c, _d;
            var product_id = product.hit_type === "master" || (!product.hit_type && product.c_defaultVariantId) ? product.c_defaultVariantId : product.product_id;
            var price = 0;
            var fullPrice = 0;
            var discount = 0;
            if (product.product_type.set) {
                price = (product.c_overrideDisplayPrice && product.c_overrideDisplayPrice !== 0) ? product.c_overrideDisplayPrice : (product.c_promoPrice && product.c_promoPrice !== 0) ? product.c_promoPrice : product.c_setTotalPrice;
                fullPrice = product.c_setTotalPrice;
                discount = fullPrice - price;
            }
            else {
                price = (product.c_overrideDisplayPrice && product.c_overrideDisplayPrice !== 0) ? product.c_overrideDisplayPrice : (product.c_promoPrice && product.c_promoPrice !== 0) ? product.c_promoPrice : product.price;
                fullPrice = product.price;
                discount = fullPrice - price;
            }
            var item_category = product.primary_category_id;
            var item_list_name = itemListName ? itemListName : isSearch ? 'Search' : (_c = (_b = (_a = window) === null || _a === void 0 ? void 0 : _a.reactPageData) === null || _b === void 0 ? void 0 : _b.cgid) !== null && _c !== void 0 ? _c : product.primary_category_id;
            var variationAttributes = ['color', 'size'];
            var item_variant = "";
            variationAttributes.forEach(function (variantAttribute) {
                var _a, _b, _c;
                var variantName = (_c = (_b = (_a = product.c_variantData) === null || _a === void 0 ? void 0 : _a.variants) === null || _b === void 0 ? void 0 : _b.find(function (variant) { return variant.id === product.c_defaultVariantId; })) === null || _c === void 0 ? void 0 : _c[variantAttribute];
                if (!!variantName)
                    item_variant = variantName;
            });
            var GA4Item = {
                item_id: product_id,
                item_name: product.product_name,
                affiliation: _this.affiliation,
                currency: (_d = window.reactSystemData) === null || _d === void 0 ? void 0 : _d.currencyCode,
                discount: (discount % 1 !== 0) ? parseFloat(discount.toFixed(2)) : discount,
                index: index,
                item_brand: _this.item_brand,
                item_category: item_category,
                item_list_name: item_list_name,
                item_variant: item_variant,
                price: fullPrice,
                quantity: 1
            };
            return GA4Item;
        }));
        (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ ecommerce: null });
        (_b = window.dataLayer) === null || _b === void 0 ? void 0 : _b.push(DLEvent);
    };
    GAService.viewItem = function (products, selected) {
        var _a, _b, _c;
        var DLEvent = this.buildEvent('view_item', this.getGA4ItemFromProductDto(products, selected, 'Product Detail Page'), {
            currency: (_a = window.reactSystemData) === null || _a === void 0 ? void 0 : _a.currencyCode,
            value: products.reduce(function (previous, current) {
                return previous + (current.promoPrice || current.price);
            }, 0),
        });
        (_b = window.dataLayer) === null || _b === void 0 ? void 0 : _b.push({ ecommerce: null });
        (_c = window.dataLayer) === null || _c === void 0 ? void 0 : _c.push(DLEvent);
    };
    GAService.fireGenericCartEvents = function (basket, eventName) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var products = (_a = basket === null || basket === void 0 ? void 0 : basket.productItems.filter(function (product) { return !product.isDonationItem; })) !== null && _a !== void 0 ? _a : [];
        var donationValue = (_d = (_c = (_b = basket === null || basket === void 0 ? void 0 : basket.productItems.filter(function (product) { return product.isDonationItem; })) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.price) !== null && _d !== void 0 ? _d : 0;
        var currency = (_e = window.reactSystemData) === null || _e === void 0 ? void 0 : _e.currencyCode;
        var options = {
            currency: currency,
            value: basket === null || basket === void 0 ? void 0 : basket.orderTotal
        };
        if (donationValue > 0) {
            options.donation_value = donationValue;
        }
        var coupons = (_g = (_f = basket === null || basket === void 0 ? void 0 : basket.couponItems) === null || _f === void 0 ? void 0 : _f.map(function (c) { var _a; return (_a = c.promotionId) !== null && _a !== void 0 ? _a : c.code; })) !== null && _g !== void 0 ? _g : [];
        if ((_h = basket === null || basket === void 0 ? void 0 : basket.paymentInstruments) === null || _h === void 0 ? void 0 : _h.some(function (pi) { return pi === 'GIFT_CERTIFICATE'; })) {
            coupons.push('GIFT_CARD');
        }
        coupons.forEach(function (coupon, index) {
            if (index === 0) {
                options['coupon'] = coupon;
            }
            else {
                options["coupon" + (index + 1)] = coupon;
            }
        });
        var DLEvent = this.buildEvent(eventName, products.map(function (product, index) {
            var _a, _b, _c;
            var discountAmount = parseFloat((product.price - product.discountedPrice).toFixed(2));
            var item_category = (_a = product.primaryCategoryId) !== null && _a !== void 0 ? _a : "";
            var product_id = product.productId;
            var variantAttribute = "Color";
            var item_variant = product.variationData ? product.variationData[variantAttribute] : "";
            var GA4Item = {
                item_id: product_id,
                item_name: product.name,
                affiliation: _this.affiliation,
                currency: currency,
                discount: product.isBonusProduct ? 0 : discountAmount % 1 !== 0 ? parseFloat(discountAmount.toFixed(2)) : discountAmount,
                index: index,
                item_brand: _this.item_brand,
                item_category: item_category,
                item_list_name: eventName === 'begin_checkout' ? '' : 'Cart',
                item_variant: item_variant !== null && item_variant !== void 0 ? item_variant : "",
                price: product.isBonusProduct ? 0 : product.basePrice,
                quantity: product.quantity,
                item_bundle_name: _this.getItemBundleName(product)
            };
            if ((((_b = product === null || product === void 0 ? void 0 : product.appliedCoupons) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0) {
                (_c = product.appliedCoupons) === null || _c === void 0 ? void 0 : _c.forEach(function (coupon, index) {
                    if (index === 0) {
                        GA4Item.coupon = coupon;
                    }
                    else {
                        GA4Item["coupon" + (index + 1)] = coupon;
                    }
                });
            }
            return GA4Item;
        }), options);
        (_j = window.dataLayer) === null || _j === void 0 ? void 0 : _j.push({ ecommerce: null });
        (_k = window.dataLayer) === null || _k === void 0 ? void 0 : _k.push(DLEvent);
    };
    GAService.cartQuantityChange = function (product, isIncrease, qtyDifference) {
        var _a, _b, _c, _d, _e, _f;
        if (!product)
            return;
        var discountAmount = product.discountedPrice > 0 ? parseFloat((product.discountedPrice / product.quantity).toFixed(2)) : 0;
        var productObject = {
            item_id: product.productId,
            item_name: product.name,
            affiliation: this.affiliation,
            currency: (_a = window.reactSystemData) === null || _a === void 0 ? void 0 : _a.currencyCode,
            discount: discountAmount ? parseFloat((product.basePrice - discountAmount).toFixed(2)) : 0,
            index: 0,
            item_brand: this.item_brand,
            item_category: (_b = product.primaryCategoryId) !== null && _b !== void 0 ? _b : "",
            item_list_name: "Cart",
            item_variant: "",
            price: product.basePrice,
            quantity: qtyDifference,
            item_bundle_name: this.getItemBundleName(product)
        };
        if ((_c = product.variationData) === null || _c === void 0 ? void 0 : _c['Color']) {
            productObject.item_variant = product.variationData['Color'];
        }
        var value = qtyDifference * product.basePrice;
        var DLEvent = this.buildEvent(isIncrease ? 'add_to_cart' : 'remove_from_cart', [productObject], {
            currency: (_d = window.reactSystemData) === null || _d === void 0 ? void 0 : _d.currencyCode,
            value: value
        });
        (_e = window.dataLayer) === null || _e === void 0 ? void 0 : _e.push({ ecommerce: null });
        (_f = window.dataLayer) === null || _f === void 0 ? void 0 : _f.push(DLEvent);
    };
    GAService.addToBagInPDP = function (product, selectedVariant, quantity, selectedSetProducts, itemListName) {
        var _this = this;
        var _a, _b, _c, _d, _e;
        if (!product)
            return;
        var currency = (_a = window.reactSystemData) === null || _a === void 0 ? void 0 : _a.currencyCode;
        var discountAmount = selectedVariant ? (selectedVariant.promoPrice && selectedVariant.promoPrice > 0 ?
            parseFloat((selectedVariant.price - selectedVariant.promoPrice).toFixed(2)) : 0) : (product.promoPrice && product.promoPrice > 0 ?
            parseFloat((product.price - product.promoPrice).toFixed(2)) : 0);
        var breadcrumbs = (_b = window.reactPageData) === null || _b === void 0 ? void 0 : _b.breadcrumbs;
        var getItemCategory = function () {
            var _a, _b, _c, _d, _e, _f;
            if (!!product.primaryCategoryId)
                return product.primaryCategoryId;
            if (!!((_b = (_a = breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs[0]) === null || _a === void 0 ? void 0 : _a.htmlValue) === null || _b === void 0 ? void 0 : _b.toLowerCase()))
                return (_d = (_c = breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs[0]) === null || _c === void 0 ? void 0 : _c.htmlValue) === null || _d === void 0 ? void 0 : _d.toLowerCase();
            if (!!((_f = (_e = window) === null || _e === void 0 ? void 0 : _e.reactPageData) === null || _f === void 0 ? void 0 : _f.categoryName))
                return window.reactPageData.categoryName;
            return '';
        };
        var productObjects = [];
        if (product.isProductSet && product.productSetProducts) {
            productObjects = product.productSetProducts.filter(function (psp) {
                return selectedSetProducts === null || selectedSetProducts === void 0 ? void 0 : selectedSetProducts.includes(psp.id);
            }).map(function (p) {
                var _a;
                var setProduct = {
                    item_id: p.id,
                    item_name: p.name,
                    affiliation: _this.affiliation,
                    currency: currency,
                    discount: discountAmount,
                    index: 0,
                    item_brand: _this.item_brand,
                    item_category: getItemCategory(),
                    item_list_name: itemListName !== null && itemListName !== void 0 ? itemListName : getItemCategory(),
                    price: p.price,
                    quantity: quantity,
                };
                var siteId = (_a = window.reactSystemData) === null || _a === void 0 ? void 0 : _a.siteId;
                if (siteId === 'sw-us') {
                    setProduct.ritual_name = product.name;
                }
                return setProduct;
            });
        }
        else {
            var productObject = {
                item_id: (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id) || product.id,
                item_name: product.name,
                affiliation: this.affiliation,
                currency: currency,
                discount: discountAmount,
                index: 0,
                item_brand: this.item_brand,
                item_category: getItemCategory(),
                item_list_name: itemListName !== null && itemListName !== void 0 ? itemListName : getItemCategory(),
                price: selectedVariant && selectedVariant.price ? selectedVariant.price : product.price,
                item_variant: "",
                quantity: quantity,
            };
            if (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.color) {
                productObject.item_variant = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.color;
            }
            productObjects.push(productObject);
        }
        var DLEvent = this.buildEvent('add_to_cart', productObjects, {
            currency: (_c = window.reactSystemData) === null || _c === void 0 ? void 0 : _c.currencyCode,
            value: productObjects.reduce(function (previous, current) {
                return (previous + current.price - current.discount) * current.quantity;
            }, 0),
        });
        (_d = window.dataLayer) === null || _d === void 0 ? void 0 : _d.push({ ecommerce: null });
        (_e = window.dataLayer) === null || _e === void 0 ? void 0 : _e.push(DLEvent);
    };
    GAService.itemSelectionEventHandler = function (product, selectedVariant, quantity, index, category, eventType, isSearch) {
        var _a, _b;
        if (!product)
            return;
        var productObject = buildGAItem(product, quantity, index, category, selectedVariant, isSearch ? 'Search' : undefined);
        var DLEvent = this.buildEvent(eventType, [productObject]);
        (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ ecommerce: null });
        (_b = window.dataLayer) === null || _b === void 0 ? void 0 : _b.push(DLEvent);
    };
    GAService.removeFromCart = function (product) {
        var _this = this;
        var _a, _b, _c, _d;
        var products = [product];
        var currency = (_a = window.reactSystemData) === null || _a === void 0 ? void 0 : _a.currencyCode;
        var value = products.reduce(function (ac, current) { return ac + current.discountedPrice; }, 0);
        var DLEvent = this.buildEvent('remove_from_cart', products.map(function (product, index) {
            var _a;
            var discount = parseFloat((product.price - product.discountedPrice).toFixed(2));
            var product_id = product.productId;
            var variantAttribute = "Color";
            var item_variant = product.variationData ? product.variationData[variantAttribute] : "";
            var GA4Item = {
                item_id: product_id,
                item_name: product.name,
                affiliation: _this.affiliation,
                currency: currency,
                discount: discount,
                index: index,
                item_brand: _this.item_brand,
                item_category: (_a = product.primaryCategoryId) !== null && _a !== void 0 ? _a : "",
                item_list_name: "Cart",
                item_variant: item_variant !== null && item_variant !== void 0 ? item_variant : "",
                price: product.basePrice,
                quantity: product.quantity,
                item_bundle_name: _this.getItemBundleName(product)
            };
            return GA4Item;
        }), {
            currency: (_b = window.reactSystemData) === null || _b === void 0 ? void 0 : _b.currencyCode,
            value: value
        });
        (_c = window.dataLayer) === null || _c === void 0 ? void 0 : _c.push({ ecommerce: null });
        (_d = window.dataLayer) === null || _d === void 0 ? void 0 : _d.push(DLEvent);
    };
    GAService.pageDataEvent = function (pageData) {
        var _a;
        var DLEvent = __assign({ event: "page_metadata" }, pageData);
        (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push(DLEvent);
    };
    GAService.affiliation = getBrandName();
    GAService.item_brand = getBrandName();
    GAService.getItemBundleName = function (product) {
        var _a;
        var itemBundleName = '';
        if ('productOptions' in product) {
            (_a = product.productOptions) === null || _a === void 0 ? void 0 : _a.forEach(function (option) {
                if (option.optionId === 'bundle' && option.optionValueId !== 'no-bundle') {
                    itemBundleName = option.optionName;
                }
            });
        }
        return itemBundleName;
    };
    return GAService;
}());
export { GAService };
//# sourceMappingURL=GAService.js.map